const ROLES = {
  SuperAdmin: 'superAdmin',
  ShippingAdmin: 'shippingAdmin',
  Admin: 'admin',
  Translator: 'translator',
  Reviewer: 'reviewer',
  Retailer: 'retailer',
  RetailerGM: 'retailerGM',
  Hac: 'hac',
  Pma: 'pma',
  PmaGM: 'pmaGM',
  MarketAdmin: 'marketAdmin',
  CountryAdmin: 'countryAdmin',
};

const MARKETS = [
  {name: 'AU_CZ_SK', countries: ['AT', 'CZ', 'SK']},
  {name: 'Benelux', countries: ['BE', 'LUX', 'NL']},
  {name: 'EIRO', countries: ['PL', 'CH', 'TR', 'IE', 'RO', 'NO', 'SE'] },
  {name: 'France', countries: ['FR']},
  {name: 'Germany', countries: ['DE']},
  {name: 'Iberia', countries: ['ES', 'PT']},
  {name: 'Italy', countries: ['IT']}
]

const HAC_STATUS = {
  Nominated: 'nominated',
  Exited: 'exited',
  Active: 'active',
};

export { ROLES, HAC_STATUS, MARKETS };
